export const criticityData = [
    { name: "Inconnue", id: "0" },
    { name: "OK", id: "1" },
    { name: "Avertissement", id: "2" },
    { name: "Critique", id: "3" },
]

export const closedData = [
    { name: "Non", id: "0" },
    { name: "Oui", id: "1" },
]